import { createWebHistory, createRouter } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Calendar from '@/views/Calendar.vue'
import Subscription from '@/views/Subscription.vue'
import Payments from '@/views/Payments.vue'
import Customers from '@/views/Customers.vue'
import Customer from '@/views/Customer.vue'
import Settings from '@/views/Settings.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: Subscription,
  },
  {
    path: '/payments',
    name: 'Payments',
    component: Payments,
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: Customer,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: {
      beforeRouteEnter(to, from, next) {
        console.log({ from });

        if (!from) {
          console.log("no from");
        }
        console.log("running before hook");
        next('login');
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
